export default {
  isMobile: false,
  responsive: {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    only: {
      xs: false,
      sm: false,
      md: false,
      lg: false,
      xl: false,
    },
  },
  loading: {
    nb: 0,
    isVisible: false,
  },
  snackbar: {
    isVisible: false,
    message: '',
    centered: true,
    type: 'info',
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/application/state.js